module.exports = __webpack_public_path__ + "img/cbd2blur.86985c73.jpg";